<div class="row">
    <div class="col-12">
        @switch (viewSelection) {
            @case (CatchupView.Graph) {
                <div>
                    <adapt-catchup-relationships-graph [focusPerson]="focusPerson"
                                                       [allowSelectPerson]="allowSelectPerson"
                                                       [allowTeamSelection]="allowTeamSelection"
                                                       [teamId]="teamId"
                                                       [catchupPeople]="teamMembers"
                                                       [showExternalStakeholder]="showExternalStakeholder"
                                                       [showTeamRelationships]="showTeamRelationships"
                                                       [getCatchups$]="getCatchups$"></adapt-catchup-relationships-graph>
                </div>
            }
            @case (CatchupView.Grid) {
                <div>
                    <adapt-catchup-grid [filterForPersonId]="focusPerson?.personId"
                                        [filterForTeamId]="teamId"></adapt-catchup-grid>
                </div>
            }
        }
    </div>
</div>
